import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from './scenes/GameIntro';

interface PhaserStarballGameProps {
    onComplete: () => void;
}

interface PhaserStarballGameState {
}

const gameConfig: GameConfig = {
    title: "Starball Game",
    version: "0.2",
    backgroundColor: "#000000",
};

class PhaserStarballGame extends React.Component<PhaserStarballGameProps, PhaserStarballGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserStarballGameProps) {
        super(props);
        bindAllOfThis(this, PhaserStarballGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserStarballGame;



// WEBPACK FOOTER //
// ./src/games/StarballGame/Main.tsx